import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import { Grid, Button, colors, Portal } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Topbar from "../global/Topbar";
import _, { parseInt, partialRight } from 'lodash';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { TextField, Select, MenuItem, FormControl, InputLabel, Input, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import Invoice from '../../components/Invoice';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';

function SellEntry(props) {
  const navigate = useNavigate();
  const itemCodeRef = useRef(null);
  const entrynoRef = useRef(null);
  let dialogContent = null;
  const [PO, setPO] = useState([]);

  const [entries, setEntries] = useState([]);
  const [showGrid, setShowGrid] = useState(true);
  const [formMode, setFormMode] = useState('edit');
  const [formModeUpdate, setFormModeUpdate] = useState('add');

  const [tableData, setTableData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [currentItems, setCurrentItems] = useState([]);

  const location = useLocation();
  const flag = new URLSearchParams(location.search).get('flag');
  const title = new URLSearchParams(location.search).get('title');
  const [editRoomId, setEditRoomId] = useState(null);
  const [intialflag, setFlag] = useState('');

  const [entryNo, setEntryNo] = useState('');
  const [trDate, setTrDate] = useState(getCurrentDate());

  const [PONo, setPONo] = useState('');
  const [PODate, setPODate] = useState(getCurrentDate());
  const [CIHeats, setCIHeats] = useState(0);
  const [DIHeats, setDIHeats] = useState(0);
  const [CIRate, setCIRate] = useState(0);
  const [DIRate, setDIRate] = useState(0);
  const [SubAccode, setSubAccode] = useState('');
  const [SubAcHead, setSubAcHead] = useState('');
  const [EmpCode, setEmpCode] = useState('');
  const [EmpName, setEmpName] = useState('');
  const [DCNo, setDCNo] = useState(0);
  const [ChNo, setChNo] = useState(0);
  const [Hours, setHours] = useState(0);
  const [BreakDownMin, setBreakDownMin] = useState(0);
  const [Ewaybill, setEwaybill] = useState(0);
  const [Remark2, setRemark2] = useState('');
  const [NatureCode, setNatureCode] = useState('');
  const [Narration, setNarration] = useState('');
  const [VehicleCode, setVehicleCode] = useState('');
  const [FurnaceTonnage, setFurnaceTonnage] = useState(0);

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [ItCode, setItCode] = useState(1);
  const [itemName, setItemName] = useState('');
  const [Qty, setQty] = useState(0);
  const [ShortQty, setShortQty] = useState(0);

  const [StatusCode, setStatusCode] = useState('0');
  const [Remark1, setRemark1] = useState('Y');

  const [Boxes, setBoxes] = useState('');
  const [PartNo, setPartNo] = useState('');
  const [Weight, setWeight] = useState('');
  const [WeightPer, setWeightPer] = useState(0);
  const [RejCode, setRejCode] = useState('');
  const [RejType, setRejType] = useState('');
  const [ProcessCode, setProcessCode] = useState('');
  const [ProcessType, setProcessType] = useState('');
  const [LabourRate, setLabourRate] = useState('');
  const [CHNo, setCHNo] = useState('');
  const [OpenClose, setOpenClose] = useState('');
  const [Remark3, setRemark3] = useState('');

  const [DeptCode, setDeptCode] = useState(0);
  const [YearCode, setYearCode] = useState(0);
  const [CompCode, setCompCode] = useState(0);
  const [UserID, setUserID] = useState(0);
  const [uniqueCode, setUniqueCode] = useState(0);

  const [Amt, setAmt] = useState(0);
  const [CostRate, setCostRate] = useState(0);
  const [TotalAmt, setTotalAmt] = useState(0);



  //Calculation
  const [Rate, setRate] = useState(0.00);
  const [GstRateCode, setGstRateCode] = useState(0);
  const [GstRate, setGstRate] = useState(0);
  const [CGstAmt, setCGstAmt] = useState(0.00);
  const [SGstAmt, setSGstAmt] = useState(0.00);
  const [IGstAmt, setIGstAmt] = useState(0.00);
  const [NetAmt, setNetAmt] = useState(0.00);

  const [GSTPercentage, setGSTPercentage] = useState(0);
  const [TotIGST, setTotIGST] = useState(0.00);
  const [TotCGST, setTotCGST] = useState(0.00);
  const [TotSGST, setTotSGST] = useState(0.00);
  const [TaxableAmt, setTaxableAmt] = useState(0.00);

  const [gstRates, setGstRates] = useState([]);
  const [SubLedgerMasterEntries, setSubLedgerMasterEntries] = useState([]);
  const [VehicleMasterEntries, setVehicleMasterEntries] = useState([]);
  const [NatureMasterEntries, setNatureMasterEntries] = useState([]);
  const [EmployeeMasterEntries, setEmployeeMasterEntries] = useState([]);
  const [ProcessMasterEntries, setProcessMasterEntries] = useState([]);
  const [RejectionMasterEntries, setRejectionMasterEntries] = useState([]);
  const [ItemMaster, setItemMaster] = useState([]);
  const [ProcessTempEntries, setProcessTempEntries] = useState([]);
  const [ProcessEntries, setProcessEntries] = useState([]);
  const [ProcessEntry, setProcessEntry] = useState([]);

  const [showPDFComponent, setShowPDFComponent] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  
  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  
  const [loading, setLoading] = useState(false);

  const [checkedEntries, setCheckedEntries] = useState({});
  const [tableTempData, setTableTempData] = useState([]); 

  let entryTotalNetAmt = {};
  /* const uniqueEntries = new Set(); */


  useEffect(() => {
    const flag = new URLSearchParams(location.search).get('flag');
    fetchProcessEntry(flag);
    fetchItemMaster();
    fetchSubLedgerMaster();
    fetchVehicleMaster();
    fetchNatureMaster();
    fetchEmpMaster();
    fetchProcessMasterEntries();
    fetchRejectionMaster();
    fetchGSTMaster();
  }, [location.search]);

  
  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.EntryNo > maxEntryNo) {
        maxEntryNo = entry.EntryNo;
      }
    }
    return maxEntryNo;
  };


 /*  const fetchProcessTempEntries = async (flag) => {
    try {
      const response = await axios.get(`https://www.wingap.net.in/api/processtemp/${flag}`);
      if (response.data.length === 0) {
        console.log('ProcessTemp Entries: Empty array');
        setProcessTempEntries([]);  // Return an empty array if there are no entries
      }

      const totalNetAmt = response.data.reduce((total, entry) => total + entry.NetAmt, 0);
      const totalIGSTAmt = response.data.reduce((total, entry) => total + entry.IgstAmt, 0);
      const totalSGSTAmt = response.data.reduce((total, entry) => total + entry.SgstAmt, 0);
      const totalCGSTAmt = response.data.reduce((total, entry) => total + entry.CgstAmt, 0);
      const totalTaxableAmt = response.data.reduce((total, entry) => total + entry.TaxableAmt, 0);

      const maxNo = calculateMaxUniqueCode(response.data);
      const nextNo = Number(maxNo) + 1;
      setUniqueCode(nextNo);

      setNetAmt(totalNetAmt);
      setTotIGST(totalIGSTAmt);
      setTotSGST(totalSGSTAmt);
      setTotCGST(totalCGSTAmt);
      setTaxableAmt(totalTaxableAmt);

      setProcessTempEntries(response.data);
      console.log("PO data : ", response);

    } catch (error) {
      console.log('error:', error);
      return [];
    }
  };*/

  const fetchProcessEntry = async (flag) => {
    try {
      const response = await axios.get(`https://www.wingap.net.in/api/processentry/${flag}`);
      if (response.data.length === 0) {
        console.log('Process Entries: Empty array');
        setTableTempData([]);  
      }
      console.log('Process Entry :', response.data);
      const maxNo = calculateMaxEntryNo(response.data);
      const nextNo = Number(maxNo) + 1;
      setEntryNo(nextNo);
      setProcessEntry(response.data);
      console.log('process Entries:', response.data);
    } catch (error) {
      console.log('Error fetching Process entries:', error);
      return [];
    }
  };


  const fetchRejectionMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/rejection');
      setRejectionMasterEntries(response.data.sort((a,b)=> a.RejCode - b.RejCode));
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchEmpMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/employee');
      setEmployeeMasterEntries(response.data.sort((a,b)=>a.EmpCode - b. EmpCode));
      console.log(response)
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchNatureMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/Nature');
      setNatureMasterEntries(response.data.sort((a,b)=>a.NatureCode - b.NatureCode));
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchVehicleMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/vehicle');
      setVehicleMasterEntries(response.data.sort((a,b)=>(a.VehicleCode - b.VehicleCode)));
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchProcessMasterEntries = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/process');
      setProcessMasterEntries(response.data.sort((a,b)=> a.ProcessCode - b.ProcessCode));
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchItemMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/items-master');
      setItemMaster(response.data.sort((a,b) => a.ItCode - b.ItCode));
      console.log("ItemMaster : ", response.data); // Log the fetched data
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchSubLedgerMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgerMaster');
      setSubLedgerMasterEntries(response.data);
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchGSTMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/gstrates');
      setGstRates(response.data);
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const handleQtyChange = (e) => {
    const newAmt = parseFloat(e.target.value) || 0;
    setQty(newAmt);
  };

  const handleShortQtyChange = (e) => {
    const newAmt = parseFloat(e.target.value) || 0;
    setShortQty(newAmt);
  };



  const handleItNameChange = async (event, newValue) => {
    // Check if newValue is falsy (undefined or null)
    if (!newValue) {
      setItCode("");
      setItemName("");
      setRate("");
      setWeightPer("");
      setGstRate(""); 
      return;
    }

    const selectedGroupName = newValue.ItName;
    setItCode(newValue);
    setItemName(selectedGroupName);

    const selectedGroup = ItemMaster.find(group => group.ItName == selectedGroupName);

    if (selectedGroup) {
      setRate(selectedGroup.CostRate);
      setWeightPer(selectedGroup.ProdnWeight);
      console.log("weightPer",selectedGroup.ProdnWeight);
      setItCode(selectedGroup.ItCode);
      setGstRate(selectedGroup.GSTRATECODE);
      try {
        const gstPercent = gstRates.find(group => group.GSTRateCode == selectedGroup.GSTRATECODE);
        handleGstRateChange(gstPercent?.GSTPercent);
      } catch (error) {
        console.error("Error fetching GST percent:", error);
      }
    }
  };


  const handlePartNoChange = (e) => {
    const selectedPartNo = e.target.value;
    const selectedGroup = ItemMaster.find(group => group.ItCode == selectedPartNo);

    if (selectedGroup) {
      setItCode(selectedGroup.ItCode);
      setRate(selectedGroup.CostRate);
      setWeightPer(selectedGroup.ProdnWeight);
    }
  };

  useEffect(() => {
    console.log("ItCode :-", ItCode);
    const selectedGroup = ItemMaster.find(group => group.ItCode == ItCode);
    if (selectedGroup) {
      setRate(selectedGroup.CostRate);
      setWeightPer(selectedGroup.ProdnWeight);
    }
  }, [ItCode, Rate , WeightPer]);


  const handleAddEntry = () => {
    const newEntry = {
      Flag:flag, 
      ItCode:  parseInt(ItCode),
      BoxQty: Boxes,
      Qty:  Qty,
      ShortQty: ShortQty,
      StatusCode: StatusCode,
      WeightPer: Number(WeightPer),
      Weight: Number(Weight),
      LabourRate: LabourRate, 
      Remark1: Remark1,
      Rate: Number(Rate),
      Amt: Number(Amt),
      ProcessCode : ProcessCode,
      RejCode : RejCode,
      NatureCode : NatureCode,
      TaxableAmt: Number(TaxableAmt),
      CgstAmt: Number(TotCGST),
      SgstAmt: Number(TotSGST),
      IgstAmt: Number(TotIGST),
      NetAmt: Number(NetAmt),
      DeptCode: props.selectedDept,
      YearCode: props.selectedYear,
      CompCode: props.selectedCompany,
      USERID: props.name,
      ComputerID: tableTempData.length + 1,
    };

    console.log(newEntry);
    setTableTempData([...tableTempData, newEntry]);
    setQty(0);
    setShortQty(0);
    setRemark1('');
    setRemark3('');
    setBoxes(0);
    setRejCode(RejectionMasterEntries[0].RejCode);
    setProcessCode(ProcessMasterEntries[0].ProcessCode);
    itemCodeRef.current.focus();

    setTimeout(() => {
      if (    itemCodeRef.current) {
            itemCodeRef.current.focus();
      }
    }, 0);
  };

  const handleUpdateEntry = (updatedEntry) => {
    // Find the index of the entry to be updated
    console.log("UpdatedEntry", updatedEntry);
    const indexToUpdate = tableTempData.findIndex(entry => entry.ComputerID == updatedEntry);
    console.log("IndexToUpdate : ", indexToUpdate);
    if (indexToUpdate !== -1) {
      // Create a copy of the entry to be updated
      const updatedTableTempData = [...tableTempData];
      updatedTableTempData[indexToUpdate] = {
        ...updatedTableTempData[indexToUpdate],

        ItCode:  parseInt(ItCode),
        BoxQty: Boxes,
        Qty:  Qty,
        ShortQty: ShortQty,
        ProcessCode: ProcessCode,
        StatusCode: StatusCode,
        RejCode: RejCode,
        WeightPer: Number(WeightPer),
        Weight: Number(Weight),
        LabourRate: LabourRate, 
        Remark1: Remark1,
        Rate: Number(Rate),
        Amt: Number(Amt),
        TaxableAmt: Number(TaxableAmt),
        CgstAmt: Number(TotCGST),
        SgstAmt: Number(TotSGST),
        IgstAmt: Number(TotIGST),
        NetAmt: Number(NetAmt),
        DeptCode: props.selectedDept,
        YearCode: props.selectedYear,
        CompCode: props.selectedCompany,
        ComputerID: updatedEntry
      };
      setTableTempData(updatedTableTempData);
      setFormMode('add');
      setTimeout(() => {
        if (itemCodeRef.current) {
          itemCodeRef.current.focus();
        }
      }, 0);

    } else {
      console.error('Entry not found for update');
    }
  };

  const AddEntry = async () => {
    let updatedTableTempData = [];

    try {
      console.log('selected while add:', flag);
      const entryData = {
        Flag:flag, 
        EntryNo: entryNo,
        TrDate: trDate,
        SubAccode: parseInt(SubAccode),
        EmpCode: EmpCode,
        PONo: PONo,
        PODate: PODate,
        DCNo: DCNo,
        CiHeats: CIHeats,
        DiHeats:  DIHeats,
        VehicleCode: VehicleCode, 
        CiRate: CIRate,
        DiRate:  DIRate,
        Hours: Hours,
        FurnaceTonnage: FurnaceTonnage,
        BreakDownMin: BreakDownMin,
        Remark2: Remark2,
        Remark3: Remark3,
        DeptCode: props.selectedDept,
        YearCode: props.selectedYear,
        CompCode: props.selectedCompany,
        USERID: props.name,
      };

      updatedTableTempData = tableTempData.map(entry => ({
        ...entry,
        ...entryData  
      }));

      const requestData = updatedTableTempData;

      await axios.post(`https://www.wingap.net.in/api/processentry/${entryNo}/${flag}`, requestData);
      fetchProcessEntry(flag);
      console.log('requestData', entryData);
      
      setItCode(ItemMaster[0].ItCode);
      setGstRate(gstRates[0].GSTRateCode);
      setGstRateCode(gstRates[0].GSTRateCode);
      const selectedGroup1 = gstRates.find(group => group.GSTRateCode == ItemMaster[0].GSTRATECODE);
      if (selectedGroup1) {
        setGstRate(selectedGroup1.GSTPercent);
      }
      setSubAccode(SubLedgerMasterEntries[0].SubAcCode);
      handleCancel(); 
      setShowPDFComponent(false);
      setTableTempData([]);

      setTimeout(() => {
        if (entrynoRef.current) {
          entrynoRef.current.focus();
        }
      }, 0);

      if(formModeUpdate === 'add'){
        toast.success('Entry Saved Successfully.', { autoClose: 600 });
      }else{
        toast.success('Entry Updated Successfully.', { autoClose: 600 });
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleCancel = async () => {
    setFormMode('add');
    // Clear input fields
    setTrDate(getCurrentDate);
    setPONo('');
    setPODate(getCurrentDate);
    setCIHeats('');
    setDIHeats('');
    setCIRate('');
    setDIRate('');
    setSubAccode(SubLedgerMasterEntries[0].SubAcCode);
    setEmpCode(EmployeeMasterEntries[0].EmpCode);
    setDCNo('');
    setChNo('');
    setBreakDownMin('');
    setRemark2('');
    setNatureCode('');
    setNarration('');
    setItCode(ItemMaster[0].ItCode);
    setQty(0);
    setShortQty(0);
    setRemark1('Y');
    setBoxes(0);
    setPartNo('');
    setWeight(0);
    setWeightPer(0);
    setStatusCode(0);
    setRejCode(RejectionMasterEntries[0].RejCode);
    setProcessCode(ProcessMasterEntries[0].ProcessCode);
    setLabourRate('');
    setFurnaceTonnage('');
    setHours('');
    setCHNo('');
    setRemark3('');
    setDeptCode('');
    setYearCode('');
    setCompCode('');
    setAmt(0);
    setRate(0);
    setTaxableAmt('');
    setIGstAmt('');
    setCGstAmt('');
    setSGstAmt('');
    setNetAmt('');
  };

  const setEditForm = (entry) => {
    console.log(" setEditForm entry", entry);
    setFormMode('edit');
    const filteredEntries = tableTempData.filter(data => data.ComputerID == entry.ComputerID && data.EntryNo == entry.EntryNo);
    setItCode(filteredEntries[0].ItCode);
    setVehicleCode(filteredEntries[0].VehicleCode);
    setDCNo(filteredEntries[0].DCNo);
    setNatureCode(filteredEntries[0].NatureCode);
    setEmpCode(filteredEntries[0].EmpCode);
    setChNo(filteredEntries[0].CHNo);
    setBreakDownMin(filteredEntries[0].BreakDownMin);
    setRemark2(filteredEntries[0].Remark2);
    const selectedGroup1 = ItemMaster.find(group => group.ItCode == filteredEntries[0].ItCode);
    if (selectedGroup1) {
      setItemName(selectedGroup1.ItName);
    }
    setBoxes(filteredEntries[0].BoxQty);
    setWeight(filteredEntries[0].Weight);
    setWeightPer(filteredEntries[0].WeightPer);
    setQty(filteredEntries[0].Qty);
    setShortQty(filteredEntries[0].ShortQty);
    setRemark1(filteredEntries[0].Remark1);
    setStatusCode(filteredEntries[0].StatusCode);
    setRejCode(filteredEntries[0].RejCode);
    const selectedGroup2 = RejectionMasterEntries.find(group => group.RejCode == filteredEntries[0].RejCode);
    if (selectedGroup2) {
      setRejType(selectedGroup2.RejName);
    }
    setProcessCode(filteredEntries[0].ProcessCode);
    const selectedGroup3 = ProcessMasterEntries.find(group => group.ProcessCode == filteredEntries[0].ProcessCode);
    if (selectedGroup3) {
      setProcessType(selectedGroup3.ProcessName);
    }
    setLabourRate(filteredEntries[0].LabourRate);
    setFurnaceTonnage(filteredEntries[0].FurnaceTonnage);
    setHours(filteredEntries[0].Hours);
    setCHNo(filteredEntries[0].CHNo);
    setRemark3(filteredEntries[0].Remark3);
    setUniqueCode(filteredEntries[0].ComputerID);
    setAmt(filteredEntries[0].Amt);
    setRate(filteredEntries[0].Rate);
    /* setTaxableAmt(filteredEntries[0].TaxableAmt);
    setTotCGST(filteredEntries[0].CgstAmt);
    setTotSGST(filteredEntries[0].SgstAmt);
    setTotIGST(filteredEntries[0].IgstAmt);
    setNetAmt(filteredEntries[0].NetAmt); */
    setUserID(filteredEntries[0].USERID);
  };

  const setEdit = (entry) => {
    setShowGrid(false);
    setFormMode('add');
    setFormModeUpdate('edit');

    const filteredEntries = ProcessEntry.filter(data => data.EntryNo == entry);
    setTableTempData(filteredEntries);
    setEntryNo(filteredEntries[0].EntryNo);
    const formattedDate = new Date(filteredEntries[0].TrDate).toISOString().split("T")[0];
    setTrDate(formattedDate);
    setSubAccode(filteredEntries[0].SubAccode);
    const selectedGroup = SubLedgerMasterEntries.find(group => group.SubAcCode == filteredEntries[0].SubAccode);
    if (selectedGroup) {
      setSubAcHead(selectedGroup.SubAcHead);
    }
    setPONo(filteredEntries[0].PONo);
    const formattedDate1 = new Date(filteredEntries[0].PODate).toISOString().split("T")[0];
    setPODate(formattedDate1);
    setCIHeats(filteredEntries[0].CiHeats);
    setDIHeats(filteredEntries[0].DiHeats);
    setCIRate(filteredEntries[0].CiRate);
    setDIRate(filteredEntries[0].DiRate);
    setItCode(filteredEntries[0].ItCode);
    setVehicleCode(filteredEntries[0].VehicleCode);
    setDCNo(filteredEntries[0].DCNo);
    setNatureCode(filteredEntries[0].NatureCode);
    setEmpCode(filteredEntries[0].EmpCode);
    setChNo(filteredEntries[0].CHNo);
    setBreakDownMin(filteredEntries[0].BreakDownMin);
    setRemark2(filteredEntries[0].Remark2);
    const selectedGroup1 = ItemMaster.find(group => group.ItCode == filteredEntries[0].ItCode);
    if (selectedGroup1) {
      setItemName(selectedGroup1.ItName);
    }
    setBoxes(filteredEntries[0].BoxQty);
    setWeight(filteredEntries[0].Weight);
    setWeightPer(filteredEntries[0].WeightPer);
    setQty(filteredEntries[0].Qty);
    setShortQty(filteredEntries[0].ShortQty);
    setRemark1(filteredEntries[0].Remark1);
    setRejCode(filteredEntries[0].RejCode);
    const selectedGroup2 = RejectionMasterEntries.find(group => group.RejCode == filteredEntries[0].RejCode);
    if (selectedGroup2) {
      setRejType(selectedGroup2.RejName);
    }
    setProcessCode(filteredEntries[0].ProcessCode);
    const selectedGroup3 = ProcessMasterEntries.find(group => group.ProcessCode == filteredEntries[0].ProcessCode);
    if (selectedGroup3) {
      setProcessType(selectedGroup3.ProcessName);
    }
    setOpenClose(filteredEntries[0].OpenClose);
    setLabourRate(filteredEntries[0].LabourRate);
    setFurnaceTonnage(filteredEntries[0].FurnaceTonnage);
    setHours(filteredEntries[0].Hours);
    setCHNo(filteredEntries[0].CHNo);
    setRemark3(filteredEntries[0].Remark3);
    console.log("DataBase && Fontend :", filteredEntries[0].Remark3, Remark3);
    setUniqueCode(filteredEntries[0].ComputerID);
    setAmt(filteredEntries[0].Amt);
    setRate(filteredEntries[0].Rate);
    /* setTaxableAmt(filteredEntries[0].TaxableAmt);
    setTotCGST(filteredEntries[0].CgstAmt);
    setTotSGST(filteredEntries[0].SgstAmt);
    setTotIGST(filteredEntries[0].IgstAmt);
    setNetAmt(filteredEntries[0].NetAmt); */
    setUserID(filteredEntries[0].USERID);
  }

  const deleteEntry = async (EntryNo, flag, uniqueid) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/processtemp/${EntryNo}/${flag}/${uniqueid}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchProcessEntry(flag);
        // await fetchProcessTempEntries(flag);
        // fetchProcessEntries(flag);
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteDistinctEntry(deleteEntryNo.entryNo, deleteEntryNo.flag);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteDistinctEntry = async (EntryNo, flag) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/distinctprocess/${EntryNo}/${flag}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        // fetchProcessEntries(flag);
        fetchProcessEntry(flag)
        setLoading(false);
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  // Function to get the current date in YYYY-MM-DD format
  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleshowandhide = async () => {
    if (showGrid === true) {
      setTableTempData([]);
      fetchProcessEntry(flag)
      setFormMode('add');
      setShowGrid(false);
      setFormModeUpdate('add');

      setCIHeats(0);
      setDIHeats(0);
      setCIRate(0);
      setDIRate(0);
      setBreakDownMin(0);
      setFurnaceTonnage(0);
      //setVehicleCode(VehicleMasterEntries[0].VehicleCode);
      setEmpCode(EmployeeMasterEntries[0].EmpCode);
      setSubAccode(SubLedgerMasterEntries[0].SubAcCode);
      setItCode(ItemMaster[0].ItCode);
      // setProcessType(ProcessMasterEntries[0].ProcessCode);
      // setRejType(RejectionMasterEntries[0].RejCode);
      setProcessCode(ProcessMasterEntries[0].ProcessCode);
      setRejCode(RejectionMasterEntries[0].RejCode);
      setNatureCode(NatureMasterEntries[0].NatureCode);
      setRemark2('');
      setQty(0);
      setWeightPer(ItemMaster[0].ProdnWeight);
      setGstRate(gstRates[0].GSTRateCode);
      setGstRateCode(gstRates[0].GSTRateCode);
      const selectedGroup1 = gstRates.find(group => group.GSTRateCode == ItemMaster[0].GSTRATECODE);
      if (selectedGroup1) {
        setGstRate(selectedGroup1.GSTPercent);
        handleGstRateChange(selectedGroup1.GSTPercent);
      }      
      setShortQty(0);
      setRemark1('');
      setBoxes('');
      setWeight(0);
      setLabourRate('');
      setRate(0);
      setAmt(0);
      setTaxableAmt('');
      setTotIGST('');
      setTotCGST('');
      setTotSGST('');
      setNetAmt('');
      //setShowPDFComponent(false);
    } else {
      if (ItemMaster.length === 1) {
        setItCode(ItemMaster[0].ItCode);
      }
      setShowGrid(true)
      setFormMode('edit');
      setFormModeUpdate('edit');
      //setShowPDFComponent(false);
    }
  };

  const handleClearTemp = async (flag) => {
    try {
      setTableTempData([]);
       handleshowandhide();
    } catch (error) {
      console.log('Error:', error);
    }
  }

  const handleGstRateChange = (selectedGstPercent) => {
    const roundedGstRate = parseFloat(selectedGstPercent).toFixed(2);
    console.log("GST Rate: ", selectedGstPercent);
    setGstRate(selectedGstPercent);

    const selectedGroup = gstRates.find(group => group.GSTPercent == selectedGstPercent);
    if (selectedGroup) {
      setGstRateCode(selectedGroup.GSTRateCode);
      const halfGstRate = (parseFloat(selectedGstPercent)).toFixed(2);
      setGSTPercentage(selectedGstPercent);
      setCGstAmt(halfGstRate);
      setSGstAmt(halfGstRate);
    }
    setIGstAmt(0.00);
  };

  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "ProcessEntryData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    AddEntry();
  };

  const handleCloseDialogWithPrint = () => {
    setShowPDFComponent(true);
    if (formModeUpdate === 'add') {
      AddEntry();
    }else {
      AddEntry();
    }
    setOpenDialog(false);
  };

  useEffect(() => {
    const totalAmt = parseFloat(Rate) * parseInt(Qty);
    setAmt(totalAmt.toFixed(2));
    if (!isNaN(Qty) && !isNaN(WeightPer)) {
      const calculatedWeight = parseInt(Qty) * parseFloat(WeightPer);
      setWeight(calculatedWeight.toFixed(2));
    }
  }, [Rate, Qty, WeightPer]);

  // Calculate CGstAmt, SGstAmt, and TotNetAmt based on GST rates
  useEffect(() => {
    const calculateTotals = () => {
      const cgstRate = parseFloat(CGstAmt) || 0;
      const sgstRate = parseFloat(SGstAmt) || 0;
      const igstRate = parseFloat(IGstAmt) || 0;
      const amtValue = parseFloat(Amt) || 0;

      if (isNaN(cgstRate) || isNaN(sgstRate) || isNaN(igstRate) || isNaN(amtValue)) {
        console.error("One or more input values are not valid numbers.");
        return;
      }
      console.log("Parsed Values:", cgstRate, sgstRate, igstRate);

      const cgstAmount = ((amtValue * cgstRate) / 2) / 100;
      const sgstAmount = ((amtValue * sgstRate) / 2) / 100;
      const igstAmount = ((amtValue * igstRate) / 2) / 100;

      let netAmt = amtValue + cgstAmount + sgstAmount;
      setNetAmt(netAmt.toFixed(2));
      setTotCGST(cgstAmount.toFixed(2));
      setTotSGST(sgstAmount.toFixed(2));
      setTotIGST(igstAmount.toFixed(2));
    };
    calculateTotals();
  }, [CGstAmt, SGstAmt, IGstAmt, Amt, GSTPercentage]);

  const handleRemarkChange = (e) => {
    const inputValue = e.target.value.toUpperCase(); // Convert input to uppercase
    if (inputValue === 'Y' || inputValue === 'N') {
      setRemark1(inputValue);
    }
  };

  const handleOpenCloseChange = (e) => {
    const inputValue = e.target.value;
    if (/^[01]$/.test(inputValue)) {
      setStatusCode(inputValue);
    }
  };

  const handleExitButtonClick = () => {
    navigate('/Dashboard');
  };

  useEffect(() => {
    const totalNetAmt = tableTempData.reduce((total, entry) => total + Number(entry.NetAmt), 0);
    const totalIGSTAmt = tableTempData.reduce((total, entry) => total + Number(entry.IgstAmt), 0);
    const totalSGSTAmt = tableTempData.reduce((total, entry) => total + Number(entry.SgstAmt), 0);
    const totalCGSTAmt = tableTempData.reduce((total, entry) => total + Number(entry.CgstAmt), 0);

    setNetAmt(totalNetAmt);
    setTotIGST(totalIGSTAmt);
    setTotSGST(totalSGSTAmt);
    setTotCGST(totalCGSTAmt);
  }, [tableTempData]);

    entryTotalNetAmt = ProcessEntry.reduce((acc, entry) => {
      if (!acc[entry.EntryNo]) {
        acc[entry.EntryNo] = 0;
      }
      acc[entry.EntryNo] += entry.Qty;
      return acc;
    }, {});
    const uniqueEntries = new Set();

  return (
    <>
      {loading && <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh' 
      }}>
        <CircularProgress sx={{ color: 'white' }} />
      </div>}
      <ToastContainer />
      {!loading && <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px', paddingTop: '0px' }}>
        <div style={!showGrid ? { display: 'flex', borderRadius: '3px', flexDirection: 'column', boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.35)', backgroundColor: '#fff', color: "black", padding: '5px' } : {}}>
          {/* New Entry Top Bar */}
          {!showGrid &&
            <>
              <div style={{ maxWidth: '100%' }}>
                <h2 style={{ fontSize: '20px', marginBottom: '10px', marginRight: '10px', marginTop: '0px' }}>{formMode === 'add' ? 'Add' : 'Edit'} {title}</h2>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px', backgroundColor: '#DEDADA', borderRadius: '5px', color: '#333', padding: '5px', width: '100%' }}>

                  <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '4px', width: '100%' }}>
                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") && <div style={{ flex: 1.1, marginRight: '5px' }}>
                      <label htmlFor="entryNo">Entry No<br /></label>
                      <input
                        type="text"
                        id="entryNo"
                        ref={entrynoRef}
                        value={entryNo}
                        readOnly
                        placeholder="EntryNo"
                        style={{ padding: '5px', width: '100%' }}
                      />
                    </div>}

                    {(flag === "PO") && <div style={{ flex: 1.1, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="PONo">PO No:</label><br />
                      <input
                        type="text"
                        id="PONo"
                        value={PONo}
                        onChange={(e) => setPONo(e.target.value)}
                        placeholder="PO No."
                        style={{ padding: '5px', width: '100%' }}
                      />
                    </div>}

                    {(flag === "PROD") && <div style={{ flex: 1, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="CIHeats">CI Heats:</label><br />
                      <input
                        type="text"
                        id="CIHeats"
                        value={CIHeats}
                        onChange={(e) => setCIHeats(e.target.value)}
                        placeholder="CI Heats"
                        style={{ padding: '5px', width: '100%' }}
                      />
                    </div>}

                    {(flag === "PROD") && <div style={{ flex: 1, marginRight: '5px' }}>
                      <label htmlFor="DIHeats">DI Heats:</label><br />
                      <input
                        type="text"
                        id="DIHeats"
                        value={DIHeats}
                        onChange={(e) => setDIHeats(e.target.value)}
                        placeholder="DI Heats"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") && <div style={{ flex: 1.5, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="Party/Contarctor">Party/Contarctor<br /></label>
                      <select
                        value={SubAccode}
                        onChange={(e) => {
                          const selectedGroupName = e.target.value;
                          setSubAccode(selectedGroupName);
                          const selectedGroup = SubLedgerMasterEntries.find(group => group.SubAcCode == selectedGroupName);
                          if (selectedGroup) {
                            setSubAccode(selectedGroup.SubAcCode);
                          }
                        }}
                        style={{ padding: '5px', width: '100%' }}
                      >
                        {SubLedgerMasterEntries.map((group) => (
                          <option key={group.SubAcCode} value={group.SubAcCode}>{group.SubAcHead}</option>
                        ))}
                      </select>
                    </div>}

                    {(flag === "IREJ" || flag === "RECD") && <div style={{ flex: 1, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="DCNo">DC No:</label><br />
                      <input
                        type="text"
                        id="DCNo"
                        value={DCNo}
                        onChange={(e) => setDCNo(e.target.value)}
                        placeholder="DC No."
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "PROD") && <div style={{ flex: 1, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="Hours">Hours</label><br />
                      <input
                        type="text"
                        value={Hours}
                        onChange={(e) => setHours(e.target.value)}
                        placeholder="Hours"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "SALES" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SENT" || flag === "RECD" || flag === "SCRAP") && <div style={{ flex: 1, marginRight: '5px' }}>
                      <label htmlFor="Ewaybill">Ewaybill</label><br />
                      <input
                        type="text"
                        id="Ewaybill"
                        value={Remark3}
                        onChange={(e) => setRemark3(e.target.value)}
                        placeholder="Ewaybill"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {( flag === "IIREJ" || flag === "SENT" || flag === "RECD" || flag === "SCRAP") && <div style={{ flex: 1, marginBottom: '5px' }}>
                      <label htmlFor="NatureCode">NatureCode</label><br />
                      <select
                        value={NatureCode}
                        onChange={(e) => {
                          const selectedGroupName = e.target.value;
                          setNatureCode(selectedGroupName);
                          const selectedGroup = NatureMasterEntries.find(group => group.NatureCode == selectedGroupName);
                          if (selectedGroup) {
                            setNatureCode(selectedGroup.NatureCode);
                            //setSubledgermasterStateCode(selectedGroup.StateCode);
                            //console.log("by acgrp name")
                          }
                        }}
                        style={{ padding: '5px', width: '100%' }}
                      >
                        {NatureMasterEntries.map((group) => (
                          <option key={group.NatureCode} value={group.NatureCode}>{group.NatureName}</option>
                        ))}
                      </select>
                    </div>}
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") && <div style={{ flex: 1, marginRight: '5px' }}>
                      <label htmlFor="TRDate">TRDate<br /></label>
                      <input
                        id="Date"
                        type="date"
                        value={trDate}
                        onChange={(e) => setTrDate(e.target.value)}
                        style={{ padding: '5px', width: '100%' }}
                      />
                    </div>}

                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', width: '100%' }}>
                      {(flag === "PO") && <div style={{ flex: 1, marginRight: '5px' }}>
                        <label htmlFor="PONo">PO Date:</label><br />
                        <input
                          type="date"
                          id="PODate"
                          value={PODate}
                          onChange={(e) => setPODate(e.target.value)}
                          placeholder="PO Date"
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}

                      {(flag === "PROD") && <div style={{ flex: 1, marginBottom: '5px', marginRight: '5px' }}>
                        <label htmlFor="CIRate">CI Rate:</label><br />
                        <input
                          type="text"
                          id="CIRate"
                          value={CIRate}
                          onChange={(e) => setCIRate(e.target.value)}
                          placeholder="CI Rate"
                          style={{ padding: '5px', width: '100%', }}
                        />
                      </div>}

                      {(flag === "PROD") && <div style={{ flex: 1, marginRight: '5px' }}>
                        <label htmlFor="DIRate">DI Rate:</label><br />
                        <input
                          type="text"
                          id="DIRate"
                          value={DIRate}
                          onChange={(e) => setDIRate(e.target.value)}
                          placeholder="DI Rate"
                          style={{ padding: '5px', width: '100%', }}
                        />
                      </div>}

                      {/* {(flag === "SALES" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SENT" || flag === "RECD" || flag === "SCRAP") && <div style={{ flex: 1, marginRight: '5px' }}>
                        <label htmlFor="VehicleNo">Vehicle No</label><br />
                        <select
                          value={VehicleCode}
                          onChange={(e) => {
                            const selectedGroupName = e.target.value;
                            setVehicleCode(selectedGroupName);
                            const selectedGroup = VehicleMasterEntries.find(group => group.VehicleCode == selectedGroupName);
                            if (selectedGroup) {
                              setVehicleCode(selectedGroup.VehicleCode);
                            }
                          }}
                          style={{ padding: '5px', width: '100%' }}
                        >
                           <option value="">Select Vehicle</option>
                          {VehicleMasterEntries.map((group) => (
                            <option key={group.VehicleCode} value={group.VehicleCode}>{group.VehicleNo}</option>
                          ))}
                        </select>
                      </div>} */}

                      {(flag === "SALES" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SENT" || flag === "RECD" || flag === "SCRAP") && (
                        <div style={{ flex: 1, marginRight: '5px' }}>
                          <label htmlFor="VehicleNo">Vehicle No</label><br />
                          <select
                            value={VehicleCode}
                            onChange={(e) => {
                              const selectedGroupName = e.target.value;
                              setVehicleCode(selectedGroupName);
                              const selectedGroup = VehicleMasterEntries.find(group => group.VehicleCode === selectedGroupName);
                              if (selectedGroup) {
                                setVehicleCode(selectedGroup.VehicleCode);
                              }
                            }}
                            style={{ padding: '5px', width: '100%' }}
                          >
                            <option value="">Select Vehicle</option>
                            {VehicleMasterEntries.map((group) => (
                              <option key={group.VehicleCode} value={group.VehicleCode}>{group.VehicleNo}</option>
                            ))}
                          </select>
                        </div>
                      )}

                      {(flag === "PO" || flag === "PROD" || flag === "IREJ" ||  flag === "SCRAP") && <div style={{ flex: 1, marginRight: '5px' }}>
                        <label htmlFor="EmpCode">EmpCode</label><br />
                        <select
                          value={EmpCode}
                          onChange={(e) => {
                            const selectedGroupName = e.target.value;
                            setEmpCode(selectedGroupName);
                            const selectedGroup = EmployeeMasterEntries.find(group => group.EmpCode == selectedGroupName);
                            if (selectedGroup) {
                              setEmpCode(selectedGroup.EmpCode);
                              //setSubledgermasterStateCode(selectedGroup.StateCode);
                              //console.log("by acgrp name")
                            }
                          }}
                          style={{ padding: '5px', width: '100%' }}
                        >
                          {EmployeeMasterEntries.map((group) => (
                            <option key={group.EmpCode} value={group.EmpCode}>{group.EmpName}</option>
                          ))}
                        </select>
                      </div>}

                      {/* <div style={{ flex: 1, marginRight: '10px' }}>
                    <label htmlFor="ChNo">CHNo:</label><br />
                    <input
                      type="text"
                      id="ChNo"
                      value={ChNo}
                      onChange={(e) => setChNo(e.target.value)}
                      placeholder="Ch No."
                      style={{ padding: '5px', width: '100%' }}
                    />
                  </div> */}

                      {(flag === "PROD") && <div style={{ flex: 1, marginRight: '5px' }}>
                        <label htmlFor="BreakdownHrs">BreakdownHrs</label><br />
                        <input
                          type="number"
                          id="BreakdownHrs"
                          value={BreakDownMin}
                          onChange={(e) => setBreakDownMin(e.target.value)}
                          placeholder="BreakdownHrs"
                          style={{ padding: '5px', width: '100%', }}
                        />
                      </div>}

                      {(flag === "PROD") && <div style={{ flex: 1, marginRight: '5px' }}>
                        <label htmlFor="FurnaceTonnage">FurnaceTonnage</label><br />
                        <input
                          type="number"
                          value={FurnaceTonnage}
                          onChange={(e) => setFurnaceTonnage(e.target.value)}
                          placeholder="FurnaceTonnage"
                          style={{ padding: '5px', width: '100%', }}
                        />
                      </div>}

                      {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") && <div style={{ flex: 1 }}>
                        <label htmlFor="Narration">Narration</label><br />
                        <input
                          type="text"
                          value={Remark2}
                          onChange={(e) => setRemark2(e.target.value)}
                          placeholder="Narration"
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}

                    </div>
                  </div>
                </div>
              </div>

            </>
          }

          {!showGrid && (
            <>
              <div style={{ display: 'flex', backgroundColor: '#DEDADA', borderRadius: '5px', marginBottom: '5px', padding: '6px' }}>
                <div style={{ width: '85%' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '4px', width: '100%' }}>

                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") && <div style={{ flex: 0.42, marginRight: '5px' }}>
                      <label htmlFor="Item Code">ItCode</label>
                      <input
                        type="number"
                        id="Item Code"
                        ref={itemCodeRef}
                        value={ItCode}
                        onInput={(e) => {
                          const entereditemCode = e.target.value;
                          setItCode(entereditemCode);
                          console.log("ItCode 1: ", ItCode);
                          if (ItemMaster.length === 1) {
                            setItCode(ItemMaster[0].ItCode);
                          }
                          const selectedGroup = ItemMaster.find(group => group.ItCode == entereditemCode);
                          console.log("ItCode 2: ", ItCode);

                          if (selectedGroup) {
                            setRate(selectedGroup.CostRate);
                            setWeightPer(selectedGroup.ProdnWeight);
                            setItemName(selectedGroup.ItName);
                            const selectedGroup1 = gstRates.find(group => group.GSTRateCode == selectedGroup.GSTRATECODE);
                            if (selectedGroup1) {
                              setGstRate(selectedGroup1.GSTPercent);
                              try {
                                const gstPercent = gstRates.find(group => group.GSTRateCode == selectedGroup1.GSTRateCode);
                                handleGstRateChange(gstPercent.GSTPercent);
                              } catch (error) {
                                console.error("Error fetching GST percent:", error);
                              }
                            } else {
                              setGstRate('');
                            }
                          } else {
                            setItemName('');
                          }

                          console.log("SellEntry ITCODE : ", ItCode);
                        }}
                        placeholder="Item Code"
                        style={{ padding: '5px', width: '100%' }}
                      />
                    </div>}

                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") &&
                      <div style={{ flex: 1.82, marginBottom: '5px', marginRight: '5px' }}>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          // options={ItemMaster}
                          options={flag === "SCRAP" ? ItemMaster.filter(item => item.ItName === "Boaring Return") : ItemMaster}
                          value={ItemMaster.find(item => item.ItCode == ItCode) || null}
                          // value={flag === "SCRAP" ? ItemMaster.find(item => item.ItName === "Boaring Return") : ItemMaster.find(item => item.ItCode === ItCode) || null}
                          onChange={(event, newValue) => handleItNameChange(event, newValue)}
                          getOptionLabel={(option) => option.ItName}
                          style={{ marginBottom: '5px', marginRight: '5px', height: '10px' }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Item Name"
                              sx={{
                                marginBottom: '5px',
                                width: '100%',
                                '& .MuiInputBase-input': {
                                  color: 'black',
                                  padding: '1px', // Adjust the padding value as needed
                                },
                                '& .MuiInputLabel-root': {
                                  color: 'black',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'black', // Set the border color
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'black', // Set the border color
                                },
                                '& .MuiSvgIcon-root': {
                                  color: 'black', // Set the color for icons
                                },
                              }}
                            />
                          )}
                        />
                      </div>}

                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") && <div style={{ flex: 1.2, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="PartNo">PartNo</label><br />
                      <select
                        value={ItCode}
                        onChange={handlePartNoChange}
                        style={{ marginBottom: '5px', padding: '5px', width: '100%' }}
                      >
                        {ItemMaster.map((group) => (
                          <option key={group.ItCode} value={group.ItCode}>{group.PartNo}</option>
                        ))}
                      </select>
                    </div>}

                    {(flag === "SENT") && <div style={{ flex: 0.52, marginRight: '5px' }}>
                      <label htmlFor="CostRate">CostRate</label><br />
                      <input
                        value={Rate}
                        disabled
                        placeholder="CostRate"
                        style={{ marginBottom: '5px', padding: '5px', width: '100%', }}
                      />
                    </div>
                    }

                    {(flag === "PROD") && <div style={{ flex: 0.52, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="Boxes">Boxes</label><br />
                      <input
                        type="number"
                        id="Boxes"
                        value={Boxes}
                        onChange={(e) => setBoxes(e.target.value)}
                        placeholder="Boxes."
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ") && <div style={{ flex: 0.52, marginRight: '5px' }}>
                      <label htmlFor="WeightPer">WeightPer</label><br />
                      <input
                        type="number"
                        value={WeightPer}
                        disabled
                        placeholder="WeightPer"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" ) && <div style={{ flex: 0.52, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="Qty">Qty</label>
                      <input
                        type="number"
                        id="Qty"
                        value={Qty}
                        onChange={handleQtyChange}
                        placeholder="Qty"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "PO") && <div style={{ flex: 0.52, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="ShortQty">ShortQty</label>
                      <input
                        type="number"
                        id="ShortQty"
                        value={ShortQty}
                        onChange={handleShortQtyChange}
                        placeholder="ShortQty"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "PO" || flag === "SALES" || flag === "PROD" || flag === "IREJ" || flag === "SENT" || flag === "RECD" || flag === "IIREJ" || flag === "IIIREJ" || flag === "SCRAP") && <div style={{ flex: 0.52, marginRight: '5px' }}>
                      <label htmlFor="Weight">Weight</label><br />
                      <input
                        type="number"
                        id="Weight"
                        value={Weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Weight"
                        disabled={flag !== "SCRAP"}
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {/* Commmented part */}
                    {/*  </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>  */}

                    {(flag === "PO") && <div style={{ flex: 0.50, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="MachiningYN">MachiningYN</label>
                      <input
                        type="text"
                        id="MachiningYN"
                        value={Remark1}
                        onChange={handleRemarkChange}
                        placeholder="Y/N"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "PO") && <div style={{ flex: 0.50, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="OpenClose">Open/Close</label><br />
                      <input
                        type="text"
                        id="OpenClose"
                        value={StatusCode}
                        onChange={handleOpenCloseChange}
                        placeholder="1 / 0"
                        style={{ padding: '5px', width: '100%', }}
                      />
                    </div>}

                    {(flag === "IREJ" || flag === "IIREJ" || flag === "IIIREJ") && <div style={{ flex: 1.2, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="RejType">RejType</label>
                      <select
                        value={RejCode}
                        onChange={(e) => {
                          const entereditemCode = e.target.value;
                          setRejCode(entereditemCode);
                          if (RejectionMasterEntries.length === 0) {
                            setRejCode(RejectionMasterEntries[0].RejCode);
                          }
                        }}
                        style={{ marginBottom: '5px', padding: '5px', width: '100%' }}
                      >
                        {RejectionMasterEntries.map((group) => (
                          <option key={group.RejCode} value={group.RejCode}>{group.RejName}</option>
                        ))}
                      </select>
                    </div>}

                    {(flag === "IREJ" || flag ==="RECD" || flag ==="SALES") && <div style={{ flex: 1.2, marginBottom: '5px', marginRight: '5px' }}>
                      <label htmlFor="ProcessType">ProcessType</label>
                      <select
                        value={ProcessCode}
                        onChange={(e) => {
                          const selectedGroupName = e.target.value;
                          setProcessCode(selectedGroupName);
                          const selectedGroup = ProcessMasterEntries.find(group => group.ProcessCode == selectedGroupName);
                          if (selectedGroup) {
                            setProcessCode(selectedGroup.ProcessCode);
                          }
                        }}
                        style={{ marginBottom: '5px', padding: '5px', width: '100%' }}
                      >
                        {ProcessMasterEntries.map((group) => (
                          <option key={group.ProcessCode} value={group.ProcessCode}>{group.ProcessName}</option>
                        ))}
                      </select>
                    </div>}

                    {/* {(flag === "SENT") && <div style={{ marginRight: '5px', flex: 0.42 }}>
                      <label htmlFor="GST Code">GST Code</label>
                      <input
                        type="number"
                        id="Gst Code"
                        value={GstRateCode}
                        readOnly
                        onInput={(e) => {
                          const entereditemCode = e.target.value;
                          setGstRateCode(entereditemCode);

                          const selectedGroup = gstRates.find(group => group.GSTRateCode === entereditemCode);
                          if (selectedGroup) {
                            setGstRate(selectedGroup.GSTPercent);
                            try {
                              // Fetch GST percent from another source
                              const gstPercent = gstRates.find(group => group.GSTRateCode == selectedGroup.GSTRateCode);
                              handleGstRateChange(gstPercent.GSTPercent);
                            } catch (error) {
                              console.error("Error fetching GST percent:", error);
                            }
                          } else {
                            setGstRate('');
                          }
                        }}
                        placeholder="GST Rate"
                        style={{ padding: '5px', width: '100%' }}
                      />
                    </div>} */}

                    {(flag === "SENT") && <div style={{ marginRight: '5px', flex: '0.60' }}>
                      <label htmlFor="GST Rate">GST Rate</label>
                      <select
                        value={GstRate}
                        onChange={(e) => {
                          const selectedGstPercent = e.target.value;
                          handleGstRateChange(selectedGstPercent);
                          console.log("selectedGstName :", selectedGstPercent);
                        }}
                        style={{ padding: '5px', width: '100%' }}
                        disabled
                      >
                        {gstRates.map((group) => (
                          <option key={group.GSTRateCode} value={group.GSTPercent}>
                            {group.GSTName}
                          </option>
                        ))}
                      </select>
                    </div>}

                    {(flag === "SENT") &&
                      <div style={{ flex: 0.62, marginRight: '5px' }}>
                        <label htmlFor="TotalAmt">TotalAmt</label><br />
                        <input
                          value={Amt}
                          disabled
                          placeholder="TotalAmt"
                          style={{ marginBottom: '5px', padding: '5px', width: '100%', }}
                        />
                      </div>}
                  </div>
                </div>
                <div>
                {showPDFComponent && (flag === "SENT") && (
                  <Invoice
                    companyName={props.selectedCompany}
                    tableData={tableTempData}
                    invoiceNo={entryNo}
                    invoiceDate={new Date(trDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                    SubAcHead={(SubLedgerMasterEntries.find(group => group.SubAcCode == SubAccode))?.SubAcHead}
                    subAcAddress={((SubLedgerMasterEntries.find(group => group.SubAcCode == SubAccode))?.Address1 || '') + ' ' + ((SubLedgerMasterEntries.find(group => group.SubAcCode == SubAccode))?.Address2 || '')}
                    City={(SubLedgerMasterEntries.find(group => group.SubAcCode == SubAccode))?.PhoneNo}
                    GSTNo={(SubLedgerMasterEntries.find(group => group.SubAcCode == SubAccode))?.GSTNO}
                    EwayBill={Remark3}
                    netamt={NetAmt}
                    ItemMaster={ItemMaster}
                    VehicleNo={(VehicleMasterEntries.find(group => group.VehicleCode == VehicleCode))?.VehicleNo}
                    showPDFComponent={showPDFComponent}
                    year={props.selectedYear}
                  />
                )}
              </div>    

              {flag === 'SENT' && (<Dialog open={openDialog} onClose={handleClose}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                  <DialogContentText>Do you want to print?</DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="inherit" onClick={handleCloseDialog}>No</Button>
                  <Button color="inherit" autoFocus onClick={handleCloseDialogWithPrint}>Yes</Button>
                </DialogActions>
              </Dialog>)}

                <div style={{ width: '20%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                  {!showGrid && (
                    <Button
                      variant="contained"
                      className="view-button"
                      onClick={formMode === 'add' ? handleAddEntry : () => handleUpdateEntry(uniqueCode)}
                      sx={{ backgroundColor: '#4caf50', color: 'white', marginBottom: '10px', marginRight: '10px' }}
                    >
                      {formMode === 'add' ? 'Add' : 'Update'}
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    className="view-button"
                    onClick={handleCancel}
                    sx={{ backgroundColor: '#f44336', color: 'white', marginBottom: '10px', marginRight: '10px' }}
                  >
                    Cancel
                  </Button>

                  {/* Add and Back Button */}
                  {(props.canEdit === true) &&(<Button
                    variant="contained"
                    className="view-button"
                    // onClick={handleshowandhide}
                    onClick={handleshowandhide}
                    sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: 'white', marginBottom: '10px' }}
                  >
                    {showGrid ? 'Add' : 'Back'}
                  </Button>)}
                </div>
              </div>
              <div ref={componentPDF} style={{ width: '100%', maxHeight: '220px', overflowY: 'auto' }}>
                {/* Item Table */}
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    border: '1px solid #ccc',
                    height: '180px',
                  }}
                >
                  <thead>
                    <tr style={{ background: '#f2f2f2', color: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
                      {/* Table headers */}
                      <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Sr No.
                      </th>
                      <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Item Code
                      </th>
                      <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Item Name
                      </th>
                      {(flag === "PROD") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Boxes
                      </th>}
                      {(flag === "SENT") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Rate
                      </th>}
                      {!(flag === "SCRAP") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        QTY
                      </th>}
                      <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Weight
                      </th>
                      {(flag === "PO") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        ShortQTY
                      </th>}
                      {(flag === "PO") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        MachineYN
                      </th>}
                      {(flag === "PO") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Open/Close
                      </th>}
                      {(flag === "IREJ" || flag === "IIREJ" || flag === "IIIREJ") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        RejType
                      </th>}
                      {(flag === "IREJ" || flag ==="RECD" || flag ==="SALES") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        ProcessType
                      </th>}
                      {(flag === "SENT") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        Amount
                      </th>}
                      {(flag === "SENT") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        CGSTAmt
                      </th>}
                      {(flag === "SENT") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        SGSTAmt
                      </th>}
                      {(flag === "SENT") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        IGSTAmt
                      </th>}
                      {(flag === "SENT") && <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                      >
                        NetAmt
                      </th>}
                      <th
                        style={{
                          padding: '4px',
                          background: '#f2f2f2',
                          border: '1px solid #ccc',
                        }}
                        className="print-hide"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>


                  <tbody>
                    {tableTempData.map((entry, index) => {
                      const selectedGroup = ItemMaster.find(group => group.ItCode == entry.ItCode);
                      const selectedGroup1 = ProcessMasterEntries.find(group => group.ProcessCode == entry.ProcessCode);
                      const selectedGroup2 = RejectionMasterEntries.find(group => group.RejCode == entry.RejCode);
                      return (
                        <tr key={entry.EntryNo} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                          {/* Render the table data for each entry */}
                          <td style={{ padding: '3px', border: '1px solid #ccc' }}>{index + 1}</td>
                          <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.ItCode}</td>
                          <td style={{ padding: '3px', border: '1px solid #ccc' }}>
                            {selectedGroup ? `${selectedGroup.ItName} : ${selectedGroup.PartNo}` : ''}
                          </td>
                          {(flag === "PROD") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.BoxQty}</td>}
                          {(flag === "SENT") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.Rate}</td>}
                          {!(flag === "SCRAP") &&<td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.Qty}</td>}
                          <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.Weight}</td>
                          {(flag === "PO") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.ShortQty}</td>}

                          {(flag === "PO") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.Remark1}</td>}
                          {(flag === "PO") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.StatusCode}</td>}

                          {(flag === "IREJ" || flag === "IIREJ" || flag === "IIIREJ") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{selectedGroup2 && selectedGroup2.RejCode !== 0 ? selectedGroup2.RejName : ''}</td>}
                          {(flag === "IREJ" || flag === "RECD" || flag ==="SALES") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{selectedGroup1 && selectedGroup1.ProcessCode !== 0 ? selectedGroup1.ProcessName : ''}</td>}
                          {(flag === "SENT") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.Amt}</td>}
                          {(flag === "SENT") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.CgstAmt}</td>}
                          {(flag === "SENT") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.SgstAmt}</td>}
                          {(flag === "SENT") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.IgstAmt}</td>}
                          {(flag === "SENT") && <td style={{ padding: '3px', border: '1px solid #ccc' }}>{entry.NetAmt}</td>}


                          <td className="print-hide" style={{ border: '1px solid #ccc' }}>
                            <button
                              className='action-btn btn-edit'
                              onClick={() => setEditForm(entry)}
                            >
                              Edit
                            </button>
                            <button
                              className='action-btn btn-delete'
                              onClick={() => deleteEntry(entry.EntryNo, entry.Flag, entry.ComputerID)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      )
                      return null;
                    })}
                  </tbody>
                </table>
              </div>

              <div style={{ marginTop: "5px", backgroundColor: '#DEDADA', borderRadius: '5px', marginBottom: '0px', padding: '6px' }}>
                <button
                  className={formModeUpdate === 'add' ? 'Save-button' : 'update-button'}
                   //onClick={formModeUpdate === 'add' ? ((flag === 'SENT') ? AddEntry() : setOpenDialog(true)) : ((flag === 'SENT') ? () => AddEntry() : setOpenDialog(true))}
                   //onClick={(e)=>setOpenDialog(true)}                  
                  onClick={() => {
                    if (flag === 'SENT') {
                      setOpenDialog(true);
                    } else {
                      AddEntry();
                    }
                  }}
                  style={{
                    padding: '10px 20px',
                    fontSize: '16px',
                    backgroundColor: formModeUpdate === 'add' ? '#4caf50' : '#2196f3',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    marginBottom: '10px',
                    marginTop: "10px"
                  }}
                >
                  {formModeUpdate === 'add' ? 'Save' : 'Update'}
                </button>
                <button
                  className="view-button"
                  onClick={handleClearTemp}
                  style={{
                    padding: '10px 20px',
                    fontSize: '16px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    marginLeft: '10px',
                    marginBottom: '10px',
                    marginTop: "10px"
                  }}
                >
                  Exit
                </button>
                <div style={{ width: '80%', display: 'flex', flexDirection: 'row', marginBottom: '10px', float: 'right' }}>
                  {(flag === 'SENT') && <div style={{ marginRight: '10px', flex: '0.4' }}>
                    <label htmlFor="TotalCGST">TotalCGST</label>
                    <input
                      type="number"
                      value={TotCGST}
                      placeholder="Total IGST"
                      readOnly
                      style={{ padding: '3px', width: '100%', textAlign: 'right' }}
                    />
                  </div>}
                  {(flag === 'SENT') && <div style={{ marginRight: '10px', flex: '0.4' }}>
                    <label htmlFor="TotalSGST">TotalSGST</label>
                    <input
                      type="number"
                      value={TotSGST}
                      placeholder="Total IGST"
                      readOnly
                      style={{ padding: '3px', width: '100%', textAlign: 'right' }}
                    />
                  </div>}
                  {(flag === 'SENT') && <div style={{ marginRight: '10px', flex: '0.4' }}>
                    <label htmlFor="TotalIGST">TotalIGST</label>
                    <input
                      type="number"
                      value={TotIGST}
                      placeholder="Total IGST"
                      readOnly
                      style={{ padding: '3px', width: '100%', textAlign: 'right' }}
                    />
                  </div>}
                  {(flag === 'SENT') && <div style={{ flex: '0.4' }}>
                    <label htmlFor="TotalAmt">TotalNetAmt</label>
                    <input
                      type="number"
                      value={NetAmt}
                      placeholder="totCrAmt"
                      readOnly
                      style={{ padding: '2px', width: '100%', textAlign: 'right', fontWeight: 'bold', fontSize: '15px', backgroundColor: 'yellow' }}
                    />
                  </div>}
                </div>
              </div>
              

            </>
          )}
        </div>
        {/* Add and Back Buttom */}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleshowandhide}
            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right', marginRight: "10px", }}
          >
            {showGrid ? 'Add' : 'Back'}
          </Button>
        </Grid>}

        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={handleExitButtonClick}
            sx={{ backgroundColor: "red", color: "white", marginBottom: "20px", float: 'right', marginRight: "10px" }}
          >
            Exit
          </Button>
        </Grid>}

        {/* Download PDF Buttom */}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px", '&:hover': { color: "white" }, }}
          >
            Download PDF
          </Button>
        </Grid>}

        {/* Export Buttom */}

        {showGrid && <Grid item>
          <Button
            variant="contained"
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px", '&:hover': { color: "white" }, }}
          >
            Export
          </Button>
        </Grid>}



        {showGrid && (
          <div ref={componentPDF} style={{ width: '100%', overflowX: 'auto' }}>
            <h2>{title} </h2>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid #ccc',
              }}
            >
              <thead style={{ display: 'table', width: '100%' }}>
                <tr style={{ background: "#f2f2f2", color: "black" }}>
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                  >
                    Flag
                  </th>
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                  >
                    EntryNo
                  </th>
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                  >
                    TrDate
                  </th>
                 {!(flag === "PROD") &&  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'25%'
                    }}
                  >
                    Party/Supplier Name
                  </th>}
                  {!(flag === "SCRAP") &&  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                  >
                    Qty
                  </th>}
                  {(flag === "SCRAP") &&  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                  >
                    Weight
                  </th>}
                  {(flag === "PO") && <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                  >
                    ShortQTY
                  </th>}
                  {(flag === "PO") && <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                  >
                    MachiningYN
                  </th>}
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc',width:'10%'
                    }}
                    className="print-hide"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody style={{ display: "block", maxHeight: "400px", overflowY: "auto", width: '100%' }}>
                {ProcessEntry
                .sort((a, b) => {
                  const dateA = new Date(a.TrDate);
                  const dateB = new Date(b.TrDate);
                  if (dateA > dateB) return -1;
                  if (dateA < dateB) return 1;
                  if (a.EntryNo > b.EntryNo) return -1;
                  if (a.EntryNo < b.EntryNo) return 1;
                  return 0;
                })
                .map((entry) => {
                    const selectedGroup = SubLedgerMasterEntries.find(group => group.SubAcCode == entry.SubAccode);
                  const uniqueKey = `${entry.EntryNo}-${entry.Flag}`;

                  if (!uniqueEntries.has(uniqueKey)) {
                    uniqueEntries.add(uniqueKey);
                  return (
                  <tr key={entry.EntryNo} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center', display: "table", width: "100%", tableLayout: "fixed" }}>
                    <td style={{ padding: '4px', border: '1px solid #ccc',width:'10%' }}>{entry.Flag}</td>
                    <td style={{ padding: '4px', border: '1px solid #ccc',width:'10%' }}>{entry.EntryNo}</td>
                    <td style={{ padding: '8px', border: '1px solid #ccc',width:'10%' }}>{new Date(entry.TrDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                    {!(flag === "PROD") && <td style={{ padding: '8px', border: '1px solid #ccc',width:'25%' }}>
                      {selectedGroup ? `${selectedGroup.SubAcHead}` : ''}
                    </td>}
                    {/* {!(flag === "SCRAP") && <td style={{ padding: '4px', border: '1px solid #ccc' }}>{entry.Qty}</td>} */}
                    {!(flag === "SCRAP") &&<td style={{ padding: '4px', border: '1px solid #ccc',width:'10%' }}>{entryTotalNetAmt[entry.EntryNo]}</td>}
                    {(flag === "SCRAP") && <td style={{ padding: '4px', border: '1px solid #ccc',width:'10%' }}>{entry.Weight}</td>}
                    {(flag === "PO") && <td style={{ padding: '4px', border: '1px solid #ccc',width:'10%' }}>{entry.ShortQty}</td>}
                    {(flag === "PO") && <td style={{ padding: '4px', border: '1px solid #ccc',width:'10%' }}>{entry.Remark1}</td>}

                    <td className="print-hide" style={{ width:'10%' }}>
                      {(props.canEdit === true) &&(<button
                        style={{
                          padding: '5px 10px',
                          backgroundColor: 'rgb(76, 175, 80)',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          marginRight: '5px',
                          marginLeft: '10px',
                        }}
                        onClick={() => setEdit(entry.EntryNo)}
                      >
                        Edit
                      </button>)}
                      {(props.canDelete === true) &&(<button
                        style={{
                          padding: '5px 10px',
                          backgroundColor: 'rgb(244, 67, 54)',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                        //onClick={() => deleteDistinctEntry(entry.EntryNo, entry.Flag)}
                        onClick={() => {
                          setDeleteEntryNo({ entryNo: entry.EntryNo, flag: entry.Flag });
                          setOpenConfirmation(true);
                        }}
                      >
                        Delete
                      </button>)}
                    </td>
                  </tr>
                  )
                }
                })}
              </tbody>
            </table>
            <Stack spacing={2} style={{ marginTop: '10px', textAlign: 'center', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Pagination
                /* count={Math.ceil(tranDistinctEntryMasterEntries.length / itemsPerPage)} */
                page={currentPage}
                // onChange={handleChangePage}
                color="primary"
                showFirstButton
                showLastButton
              />
            </Stack>

            {/* Confirmation Dialog */}
            <Dialog
              open={openConfirmation}
              onClose={() => setOpenConfirmation(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"CONFIRM DELETE"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to DELETE this Entry ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                  Cancel
                </Button>
                <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>   

          </div>
        )}
        {/* Snackbar for displaying error messages */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
        >
          <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
            {errorMessage}
          </MuiAlert>
        </Snackbar>

      </div>}
    </>
    
  );
}

export default SellEntry;
